import React, { useEffect, useState } from "react";
import Breadcrumbs from "../common/breadcrumbs";
import AOS from "aos";
import "aos/dist/aos.css";
import { useForm, SubmitHandler } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
// import { useSelector } from "react-redux";
// import { ContactUs } from "../../core/data/interface/interface";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
// import { Link } from "react-router-dom";
import Header from "../common/header";
import { addContactUs, resetContactUs } from "../../core/data/redux/action";
import { AppDispatch, RootState } from "../../core/data/redux/store";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link } from "react-router-dom";
import Footer from "../common/footer";

const Contact = () => {
  // const data = useSelector((state: ContactUs) => state.contactdata);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);



  const { user, systemSettings, contactUsLoading, contactUsSuccess, contactUsError } = useSelector(
    (state: RootState) => ({
      contactUsSuccess: state.contactUs.contactUsSuccess,
      contactUsError: state.contactUs.contactUsError,
      contactUsLoading: state.contactUs.contactUsLoading,
      systemSettings: state.auth.systemSettings,
      user: state.auth.user,
    })
  );


  const [toastMessage, setToastMessage] = useState('');
  const [toastClass, setToastClass] = useState('bg-success text-white');



  type FormValues = {
    name: string;
    email: string;
    message: string;
    phone: string;
  };

  const schema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    message: Yup.string().required("Message is required"),
    phone: Yup.string()
      .matches(/^\d+$/, "Phone must be only digits")
      .min(10, "Phone must be at least 10 digits")
      .required("Phone is required"),
  });



  const {
    register,
    handleSubmit,
    formState: { errors },
    reset: contactReset,
    // setValue,
    // trigger,
    reset,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      name: user?.name,
      email: user?.email,
      message: "",
      phone: user?.mobile,


    },
  });


  const onSubmit: SubmitHandler<FormValues> = (data) => {

    dispatch(addContactUs({
      ...data,
       vehicle_id: "",
      query_type: "enquiry",
      fairental_message: `Hi Fairental team, we have a car enquiry from a customer ${data?.name}, ${data.phone}, ${data.email}, 
      Enquiry :${data.message}`

    }));

  };



  useEffect(() => {
    if (contactUsSuccess) {
      showToast(contactUsSuccess);
      reset();
      dispatch(resetContactUs());
      // navigate(routes.bookingAddon);
    } else if (contactUsError) {
      showToast(contactUsError);
      // reset();
      dispatch(resetContactUs());
    }

  }, [dispatch, contactUsSuccess, contactUsError]);


  const showToast = (message: any) => {
    setToastClass((contactUsError) ? 'bg-danger text-white' : 'bg-success text-white')

    setToastMessage(message);
  };


  const handleCloseToast = () => {
    setToastMessage('');

  };


  const contactData = [
    {
      type: "phone",
      icon: "feather icon-phone-call",
      title: "Phone Number",
      link: "tel:+15025921994",
      text: "+15025921994",
    },
    {
      type: "email",
      icon: "feather icon-mail",
      title: "Email Address",
      link: "mailto:support@fairental.com",
      text: "support@fairental.com",
    },
    {
      type: "location",
      icon: "feather icon-map-pin",
      title: "Location",
      link: "#;",
      text: systemSettings?.default_pickup_location,
    },
    {
      type: "hours",
      icon: "feather icon-clock",
      title: "Opening Hours",
      link: "#;",
      text: "Mon - Sun (00:00 - 12:00)",
    },
  ];



  useEffect(() => {
    if (toastMessage) {
      if (toastClass === 'bg-danger text-white') {
        toast.error(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
      } else {
        toast.success(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
      }

    }
  }, [toastMessage, toastClass]);


  useEffect(() => {

    if (user) {
      contactReset({
        name: user.name ?? "",
        email: user.email ?? "",
        phone: user.mobile ?? "",
        message: "",
      });
    }
  }, [user, contactReset, contactUsSuccess]);

  return (
    <div className="main-wrapper">
      <Header />
      <Breadcrumbs title="Contact us" subtitle="Pages" />
      {/* {toastMessage && (
        <>
          {toastClass === 'bg-danger text-white'
            ? toast.error(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
            : toast.success(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })}
          <ToastContainer autoClose={3000} />
        </>
      )} */}
      <ToastContainer autoClose={3000} />

      <section className="contact-sections">
        <div className="container">
          <div className="contact-info-area">
            <div className="row">
              {contactData.map((info: any, index: number) => (
                <div
                  key={index}
                  className="col-lg-3 col-md-6 col-12 d-flex"
                  data-aos="fade-down"
                  data-aos-duration={1200}
                  data-aos-delay="0.1"
                >
                  <div className="single-contact-info flex-fill">
                    <span>
                      <i className={info.icon} />
                    </span>
                    <h3>{info.title}</h3>
                    {info.type === "phone" ? (
                      <Link to={info.link}>{info.text}</Link>
                    ) : (
                      <p>
                        <Link to={info.link}>{info.text}</Link>
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className="form-info-area"
            data-aos="fade-down"
            data-aos-duration={1200}
            data-aos-delay="0.5"
          >
            <div className="row">
              <div className="col-lg-6 d-flex">
                <ImageWithBasePath
                  src="assets/img/contact-info.jpg"
                  className="img-fluid"
                  alt="Contact"
                />
              </div>
              <div className="col-lg-6">
                <form onSubmit={handleSubmit(onSubmit)} >
                  <div style={{ maxWidth: "600px", margin: "auto", padding: "20px", backgroundColor: "white", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>


                    <div className="row">

                      <div className="col-md-12">
                        <h1>Get in touch!</h1>
                      </div>

                      <div className="col-md-12">
                        <div className="input-block">
                          <label>
                            Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control mb-0 ${errors.name ? "is-invalid" : ""}`}

                            placeholder=""
                            {...register("name")}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="input-block">
                          <label>
                            Email Address <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control mb-0 ${errors.email ? "is-invalid" : ""}`}

                            placeholder=""
                            {...register("email")}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="input-block">
                          <label>
                            Phone number <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className={`form-control mb-0 ${errors.phone ? "is-invalid" : ""}`}
                            placeholder=""
                            {...register("phone")}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="input-block">
                          <label>
                            Comments <span className="text-danger">*</span>
                          </label>
                          <textarea
                            className={`form-control mb-0 ${errors.message ? "is-invalid" : ""}`}
                            rows={4}
                            cols={50}
                            placeholder=""
                            defaultValue={"\t\t\t\t\t\t\t\t\t\t\t"}
                            {...register("message")}
                          />
                        </div>
                      </div>
                    </div>



                    <div className="text-end">
                      <button type="submit" className="btn contact-btn" disabled={contactUsLoading}>  {contactUsLoading ? "Sending.." : "Send Enquiry"}</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* <section className="contact-section">
        <div className="container">

          <div

            data-aos="fade-down"
            data-aos-duration={1200}
            data-aos-delay="0.5"
          >
            <div className="row">
              <div className="col-lg-6 ">


                <div style={{ maxWidth: "600px", margin: "auto", padding: "20px", backgroundColor: "white", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
                  <h5>Contact Us</h5>
                  <div className="input-block">
                    <p className="py-2" >
                      FairPY has a strong and committed sales staff with years of experience satisfying our customer&#39;s needs.
                    </p>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
                    <i className="fas fa-home" style={{ marginRight: "10px", }}></i>
                    <div className="input-block">
                      <label>   Address  </label>

                      <p>880 SW 15th St #3 Forest Lake, MN 55025, USA</p>
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
                    <i className="fas fa-phone-alt" style={{ marginRight: "10px", }}></i>
                    <div className="input-block">
                      <label>Phone</label>
                      <p><a href="tel:8338324779" style={{ textDecoration: "none", }}>833-832-4779</a></p>
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
                    <i className="fas fa-envelope" style={{ marginRight: "10px", }}></i>
                    <div className="input-block">
                      <label>Email</label>
                      <p><a href="mailto:admin@fairreturns.com" style={{ textDecoration: "none", }}>admin@fairreturns.com</a></p>
                    </div>
                  </div>

                  {/* <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
                    <i className="fab fa-facebook" style={{ marginRight: "10px", color: "#1877f2" }}></i>
                    <div>
                      <strong>Facebook</strong>
                      <p><Link to="https://www.facebook.com/gofairpy" target="_blank" style={{ textDecoration: "none", color: "#1877f2" }}>www.facebook.com/gofairpy</Link></p>
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
                    <i className="fab fa-instagram" style={{ marginRight: "10px", color: "#E4405F" }}></i>
                    <div>
                      <strong>Instagram</strong>
                      <p><Link to="https://www.instagram.com/gofairpy" target="_blank" style={{ textDecoration: "none", color: "#E4405F" }}>www.instagram.com/gofairpy</Link></p>
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <i className="fab fa-twitter" style={{ marginRight: "10px", color: "#1DA1F2" }}></i>
                    <div>
                      <strong>Twitter</strong>
                      <p><Link to="https://www.twitter.com/gofairpy" target="_blank" style={{ textDecoration: "none", color: "#1DA1F2" }}>www.twitter.com/gofairpy</Link></p>
                    </div>
                  </div> 
                </div>


              </div>
              <div className="col-lg-6">


                <form onSubmit={handleSubmit(onSubmit)} >
                  <div style={{ maxWidth: "600px", margin: "auto", padding: "20px", backgroundColor: "white", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>


                    <div className="row">

                      <div className="col-md-12">
                        <h5>Get in touch</h5>
                        <p> Feel free to browse our massive inventory online. If you got any questions, please do not hesitate to send us a message. We reply within 24 hours !</p>

                      </div>

                      <div className="col-md-12">
                        <div className="input-block">
                          <label>
                            Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control mb-0 ${errors.name ? "is-invalid" : ""}`}

                            placeholder=""
                            {...register("name")}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="input-block">
                          <label>
                            Email Address <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control mb-0 ${errors.email ? "is-invalid" : ""}`}

                            placeholder=""
                            {...register("email")}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="input-block">
                          <label>
                            Phone number <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className={`form-control mb-0 ${errors.phone ? "is-invalid" : ""}`}
                            placeholder=""
                            {...register("phone")}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="input-block">
                          <label>
                            Comments <span className="text-danger">*</span>
                          </label>
                          <textarea
                            className={`form-control mb-0 ${errors.message ? "is-invalid" : ""}`}
                            rows={4}
                            cols={50}
                            placeholder=""
                            defaultValue={"\t\t\t\t\t\t\t\t\t\t\t"}
                            {...register("message")}
                          />
                        </div>
                      </div>
                    </div>



                    <div className="text-end">
                      <button type="submit" className="btn contact-btn" disabled={contactUsLoading}>  {contactUsLoading ? "Sending.." : "Send Enquiry"}</button>
                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Contact;
